import React from 'react';
import { motion } from 'framer-motion';
export function SoundWave() {
  const bars = Array.from({
    length: 40
  }).map((_, i) => ({
    id: i,
    baseHeight: 20 + Math.random() * 60,
    delay: i * 0.05
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-25 flex items-center justify-center" data-id="element-236">
      <div className="flex items-center gap-1 md:gap-2 h-full w-full max-w-7xl mx-auto px-4" data-id="element-237">
        {bars.map(bar => <motion.div key={bar.id} className="w-1 md:w-2 bg-peoplecall/40 rounded-full" initial={{
        height: `${bar.baseHeight}%`
      }} animate={{
        height: [`${bar.baseHeight}%`, `${bar.baseHeight * 1.5}%`, `${bar.baseHeight}%`]
      }} transition={{
        duration: 1.5 + Math.random(),
        repeat: Infinity,
        ease: 'easeInOut',
        delay: bar.delay
      }} data-id="element-238" />)}
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-white" data-id="element-239" />
      <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-white" data-id="element-240" />
    </div>;
}